// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/foundations/shadows.ts
export const shadows = {
  xs: '0 2px 4px 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  sm: '0 2px 4px 0 rgba(218, 221, 224, 0.5)',
  md: '0 4px 8px 0 rgba(69, 76, 86, 0.13)',
  lg: '0 8px 16px 0 rgba(67, 86, 100, 0.2)',
  xl: '-16px 16px 32px 0 rgba(67, 86, 100, 0.17)',
  outline: '0 0 0 2px rgba(183, 188, 214, 0.6)',
  'outline-default': '0 0 0 2px rgba(183, 188, 214, 0.6)',
  'outline-brand': '0 0 0 2px var(--chakra-colors-brand-300)',
  'outline-gray': '0 0 0 2px var(--chakra-colors-gray-300)',
  'outline-red': '0 0 0 2px var(--chakra-colors-red-300)',
  'outline-orange': '0 0 0 2px var(--chakra-colors-orange-300)',
  'outline-yellow': '0 0 0 2px var(--chakra-colors-yellow-300)',
  'outline-green': '0 0 0 2px var(--chakra-colors-green-300)',
  'outline-teal': '0 0 0 2px var(--chakra-colors-teal-300)',
  'outline-blue': '0 0 0 2px var(--chakra-colors-blue-300)',
  'outline-cyan': '0 0 0 2px var(--chakra-colors-cyan-300)',
  'outline-purple': '0 0 0 2px var(--chakra-colors-purple-300)',
  'outline-pink': '0 0 0 2px var(--chakra-colors-pink-300)',
}
